import PropTypes from "prop-types";
import CodeBlock from "react-syntax-highlighter/dist/esm/prism-light.js";
import { dracula } from "react-syntax-highlighter/dist/esm/styles/prism";

import CopyCode from "components/CopyToClipboardButton";

const Codeblock = ({
  code,
  showCopyButton = true,
  codeblockProps,
  copyButtonProps = { label: "Copy" },
}) => {
  const isLargerScreen = window.innerWidth > 768;

  return (
    <div className="relative">
      <CodeBlock
        wrapLines
        className="neeto-molecules-code-block p-4 pr-12 md:pr-4"
        codeTagProps={{ "data-testid": "code-block-content" }}
        data-testid="code-block"
        language="javascript"
        style={dracula}
        {...codeblockProps}
      >
        {code}
      </CodeBlock>
      {showCopyButton && (
        <CopyCode
          className="absolute right-2 top-2"
          data-testid="copy-to-clipboard-button"
          size="small"
          style="secondary"
          value={code}
          {...copyButtonProps}
          label={isLargerScreen ? copyButtonProps.label : ""}
        />
      )}
    </div>
  );
};

Codeblock.propTypes = {
  /**
   * The code to be displayed.
   */
  code: PropTypes.string,
  /**
   * Flag to determine whether the 'Copy' button is displayed.
   */
  showCopyButton: PropTypes.bool,
  /**
   * Additional props that can be passed on to the 'PrismLight' component from 'react-syntax-highlighter'.
   */
  codeblockProps: PropTypes.object,
  /**
   * Additional props that can be passed on to the 'CopyToClipboardButton' component from 'neeto-molecules'.
   */
  copyButtonProps: PropTypes.object,
};

export default Codeblock;
